import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import newsBackground from "../../../images/news-sec.jpg";
import { Col, Container, Row } from "react-bootstrap"
import * as styles from "./HeroBanner.module.css"

const HeroBanner = ({ data }) => {
  const posts = data.nodes

  // Filter and sort articles
  const filteredPosts = posts
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3)

  const swiperSettings = {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: { delay: 5000 },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    className: "swiper-slide-01"
  }

  return (
    <>
      <section className={`${styles.bgSlide} slider-section main-news-slider-wrap news-slider-hero-wrap`}>
        <Swiper {...swiperSettings}>
          {filteredPosts?.map((article) => {
            const {
              title,
              uri,
              featuredImage,
              categories,
              date
            } = article

            return (
              <SwiperSlide
                key={article?.slug}
                className=" swiper-slide"
              >
                <div
                  className="news-inner-item"
                  style={{
                    background: `url(${featuredImage?.node?.localFile?.publicURL}) 0 0 no-repeat`
                  }}
                ></div>
                <div className="news-inner-blue-wrap">
                  <Container>
                    <Col className="news-content-sec">
                      <Row>
                        <Col md={8} className="dd-inr-lt-col">
                          <div className="animated time-text">
                            {date}
                          </div>
                          <p className={`${styles.title} text-size-44`} style={{ color: "#fff" }}>
                            {title}
                          </p>
                          <ul className="article-profile-list text-white d-flex">
                            <li className="mx-3">
                              Categories {": "}
                              {categories?.nodes?.map((cat, index) => (
                                <span key={cat.slug}>
                                {index > 0 && ", "}
                                  <Link to={cat.uri} className="text-white text-decoration-none">{cat.name}</Link>
                              </span>
                              ))}
                            </li>
                          </ul>
                        </Col>
                        <Col md={4} className="news-continue-btn-sec">
                        <div className="banner-white-btn-sec">
                            <Link to={uri} className={`${styles.btnArrow} btn white-btn`}>
                              <StaticImage
                                src="../../../images/white-rt-arrow.png"
                                alt="Next"
                                className="ar-23 mt-1 me-2"
                                placeholder="blurred"
                              />
                              <StaticImage
                                src="../../../images/next-arrow.png"
                                width={18}
                                height={12}
                                className="ar-23 mt-1 me-2"
                                alt="Arrow Icon"
                              />
                              Continue Reading
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Container>
                </div>
              </SwiperSlide>
            )
          })}
          <div className="swiper-btn-nav w-center-slide-arrow bg-blue">
            <div className="swiper-button-prev">
              <StaticImage
                src="../../../images/white-lt-arrow.png"
                alt="Prev"
                className="ar-23"
              />
            </div>
            <div className="swiper-button-next">
              <StaticImage
                src="../../../images/white-rt-arrow.png"
                alt="Next"
                className="ar-23"
              />
            </div>
          </div>
        </Swiper>
      </section>
      <section className="news-main-bluebar"
               style={{
                 backgroundImage: `url(${newsBackground})`,
               }}>
        <Container>
          <Row>
            <Col md={3}>
              <div className={`${styles.subTitleHead} text-size-24 mb-0 white-color news-main-title d-flex align-items-center gap-3`}>
                <StaticImage
                  src="../../../images/logo-icon.png"
                  width={41}
                  height={41}
                  alt="arrow"
                />Millennium News
              </div>
            </Col>
            <Col md={9}>
              <div className="news-top-desc">
                <p>The Digital Diary is the No. 1 online resource dedicated to bringing the latest Digital Business
                  Transformation & Leadership content to C-Suite executives from North America’s most progressive
                  industries.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HeroBanner;
